<template>
  <div>
    <v-data-table
    :page.sync="page"
    @page-count="pageCount = $event"
    :items="students"
    :headers="headers"
    hide-default-footer
    >
    <template v-slot:item.type="{ item }">
      <span class="table-complete-name">{{item.type}}</span>
    </template>
    
    <template v-slot:item.group_code="{ item }">
      <span class="table-complete-group_code">{{item.group_code}}</span>
    </template>
    
    <template v-slot:item.session="{ item }">
      <span class="table-complete-session">{{item.session}}</span>
    </template>
    
    <template v-slot:item.days="{ item }">
      <span class="table-complete-days d-block">{{item.day}}</span>
      <span class="table-complete-days">{{item.date}}</span>
    </template>
    
    <template v-slot:item.time="{ item }">
      <span class="table-complete-time">{{item.time}}</span>
    </template>
    
    <template v-slot:item.home_work="{ item }">
      <a :href="item.work_file" target="_blank">
      
      <v-btn color="#E41B1BF7" elevation="1" dark small>
        <v-icon dense class="mr-2">fas fa-file-pdf</v-icon>{{item}}
      </v-btn>
    </a>
    </template>
    <template v-slot:item.uploaded_work="{ item }">
      <v-btn :href="item.uploaded_work" color="#E41B1BF7" elevation="1" dark small>
        <v-icon dense class="mr-2">fas fa-file-pdf</v-icon>Download
      </v-btn>
    </template>
    
    
    <template v-slot:item.action="{ item }">
      
      <v-icon @click="uploadWork(item)" color="success">mdi-file-edit</v-icon>
      
    </template>
  </v-data-table>
  <div class="pa-2 d-flex justify-end">
    <span class="pa-2">
      Total Enquiries
      <span
      :style="{'color':this.$vuetify.theme.themes.light.primary}"
      >{{students.length}}</span>
    </span>
    <v-spacer></v-spacer>
    <v-pagination circle v-model="page" :length="pageCount"></v-pagination>
  </div>
  
  
  <v-dialog v-model="dialog" persistent max-width="600px">
    <template v-slot:activator="{ on, attrs2 }">
      <!--           
        <v-btn color="#6A158E" dark  v-bind="attrs2"
        v-on="on">+ Add Session</v-btn> -->
      </template>
      <v-card>
        <v-card-title>
          <span class="headline">Upload Work</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-col cols="12" sm="12" md="12">
              <label class="custom-label">Work File</label>
              <v-file-input
              label="Choose File"
              @change="fileSelected"
              accept="application/pdf"
              persistent-hint
              hint="File Should be PDF"
              show-size
              counter
              chips
              solo
              ></v-file-input>
            </v-col>
          </v-container>
        </v-card-text>
        
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="dialog = false">Close</v-btn>
          <v-btn color="blue darken-1" text @click="storeWork">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
  
</template>

<script>
  export default {
    name: "WorkTable",
    methods: {
      makeQueryParams(){
        const user = JSON.parse(localStorage.getItem("user"));
        
        return {
          ...this.formQueryParams(),
          tutor:user.id,
          status: 2
        }
      },
      fileSelected(file) {
        console.log(file)
        var reader = new FileReader()
        reader.readAsDataURL(file)
        reader.onload = ()=> {
          this.data.file = reader.result
          console.log(reader.result)
        };
        // this.data.files = [...file]
      },
      getItems(){
        const user = JSON.parse(localStorage.getItem("user"));
        
        this.loading=true
        axios.get(apiRoutes.students.works,{
          params:{
            username : user.username,
          }
        }).then(response=>{
          console.log(response.data.group_sessions)
          this.loading = false
          this.students = response.data
        })
      },
      uploadWork(item){
        console.log(item)
        this.data.work_session_wise_id = item.work_session_wise_id
        this.dialog = true
      },
      storeWork(){
        axios.post("store/student/work",this.data).then(response => {
          console.log(response);
          this.dialog = false
        })
      }
    },
    mounted() {
      
      this.getItems()
    },
    data() {
      return {
        dialog: false,
        page: 1,
        pageCount: 3,
        itemsPerPage: 10,
        data : {},
        headers: [
        { text: "Srno.", sortable: true, value: "work_session_wise_id" },
        { text: "Class", value: "group_session.group.class.class_name", sortable: true },
        { text: "Subject", value: "group_session.group.subject.subject_name", sortable: false },
        { text: "Tutor Name", value: "group_session.group.tutor.tutor_fname", sortable: true },
        { text: "Session", value: "group_session.group_session_id", sortable: true },
        { text: "Home Work", value: "home_work", sortable: false },
        { text: "Class Work", value: "home_work", sortable: false },
        { text: "Uploaded Work", value: "uploaded_work", sortable: false },
        { text: "Action", value: "action", sortable: false }
        ],
        students: [
        
        ]
      };
    }
  };
</script>

<style lang="scss">
  .v-data-table-header th span {
    font: 300 14px Gotham;
    font-family: "Gotham Narrow";
    color: #8898aa;
  }
  
  .table-complete {
    &-srno {
      font: 500 14px/13px Gotham;
      color: #172b4d;
    }
    &-name {
      display: block;
      font: 500 14px/13px Gotham;
      color: #6a158e;
    }
    &-group_code {
      font: 500 14px/13px Gotham;
      color: #0ebddff7;
    }
    &-time {
      display: block;
      font: 400 14px/10px Gotham;
      color: #0e0edff7;
    }
    &-days {
      font: 400 14px/15px Gotham;
      color: #172b4db3;
    }
    &-session {
      font: 500 14px/13px Gotham;
      color: #f0cb00;
    }
  }
</style>